// Campus campus-web features/ai/lib 에서 옮겨 왔다(PICNIC-MB-FIELD-001 §6 3단계 — 놀이터 진짜 카메라). 고칠 때는 두 곳을 함께.
/**
 * 분류기 팩토리(PAI-04) — 기기가 tf.js 를 돌릴 수 있으면 정확 모델, 아니면 무의존 폴백. <b>자동 폴백</b>이 요점이다:
 * 학교 태블릿 편차(사양·오프라인·차단)를 흡수해, 좋은 기기는 정확하게·약한 기기는 끊기지 않게 한다.
 */
import { SimpleClassifier, type Classifier, type SavedModel } from "./classifier";
import { TfClassifier, loadTf } from "./tf-classifier";

/** tf.js 로드를 시도해 성공하면 {@link TfClassifier}, 실패하면 {@link SimpleClassifier}. 던지지 않는다. */
export async function createClassifier(load: typeof loadTf = loadTf): Promise<Classifier> {
  try {
    return new TfClassifier(await load());
  } catch {
    return new SimpleClassifier();   // 오프라인·미지원·차단 — 끊기지 않게 폴백
  }
}

/** 저장본을 되살린다 — kind 로 갈린다. tf 저장본인데 tf 를 못 쓰면 빈 간단 모델(다른 특징 공간이라 못 읽음 · 재학습). */
export async function restoreClassifier(saved: SavedModel, load: typeof loadTf = loadTf): Promise<Classifier> {
  if (saved.kind === "tf") {
    try { return TfClassifier.restore(await load(), saved.data); } catch { return new SimpleClassifier(); }
  }
  return SimpleClassifier.restore(saved.data);
}
